import { Activities } from "../components/Activities";
import { InnerPageHero } from "../components/InnerPageHero";

export function ActivitiesPage() {
  return (
    <main id="top">
      <InnerPageHero kicker="AIYSS / ACTIVITIES" title="活動内容" />
      <Activities />
    </main>
  );
}
